import nist_logo from '@assets/img/complainceFamilyIcons/nist_logo.svg';
import cis_logo from '@assets/img/complainceFamilyIcons/cis_logo.svg';
// import ccm_logo from '@assets/img/complainceFamilyIcons/ccm_logo.png';
import iso_logo from '@root/assets/img/complainceFamilyIcons/ISO SVG.svg';
import aws_light from '@root/assets/img/complainceFamilyIcons/AWS SVG.svg';
import popi_logo from '@root/assets/img/complainceFamilyIcons/popi_small.svg';
import hipaa_logo from '@root/assets/img/complainceFamilyIcons/Hippa.svg';
import soc_logo from '@root/assets/img/complainceFamilyIcons/soc_small.svg';
import iso_new from '@root/assets/img/complainceFamilyIcons/iso_2013_small.svg';
import pci_logo from '@root/assets/img/complainceFamilyIcons/pci_small.svg';
import gdpr_logo from '@root/assets/img/complainceFamilyIcons/gdpr_small.svg';
import ccmd_logo from '@root/assets/img/complainceFamilyIcons/csa_small.svg';
import nydfs_logo from '@root/assets/img/complainceFamilyIcons/NYDFS_.png';
import fisma_logo from '@root/assets/img/complainceFamilyIcons/FISMA_.png';
import fedramp_logo from '@root/assets/img/complainceFamilyIcons/FedRAMP_.png';
import cmmc_logo from '@root/assets/img/complainceFamilyIcons/CMMC.svg';
// import cis_gcp from '@root/assets/img/complainceFamilyIcons/CIS-GCP-1-3-0.svg';
import gcp_well from '@root/assets/img/complainceFamilyIcons/GCP-Well-Architected_v2020-07-02.svg';
import sama from '@root/assets/img/complainceFamilyIcons/SAMA.png';
import cbb from '@root/assets/img/complainceFamilyIcons/CBB.svg';
import azwaf from '@root/assets/img/complainceFamilyIcons/azwaf.png';
import sebi_cscrf from '@root/assets/img/complainceFamilyIcons/sebi_cscrf.png';
import owasp_top_10 from '@root/assets/img/complainceFamilyIcons/owasp_top_10.png';
import mas_logo from '@root/assets/img/complainceFamilyIcons/MAS.jpeg';
import hitrust_logo from '@root/assets/img/complainceFamilyIcons/logo-hitrust.png';

import { azure_icon } from '@root/components/utilities/CloudIconsUtil';

import nist_csf_logo from '@root/assets/img/complainceFamilyIcons/nist_csf_logo.svg';
import rbi_logo from '@root/assets/img/complainceFamilyIcons/rbi_logo.svg';

const ComplianceIconMapping = ({ name, ...props }) => {
  return (
    <img
      {...props}
      src={
        name === 'CIS-GCP-1-3-0' ||
        name === 'CIS-AZURE-STORAGE_v1.0.0' ||
        name === 'CIS-AZURE-DATABASE_v1.0.0' ||
        name === 'CIS-AZURE-COMPUTE_v1.0.0' ||
        name === 'CIS-AZURE_v3.0.0'
          ? cis_logo
          : name === 'CIS-GCP_v2.0.0'
            ? cis_logo
            : name === 'CIS-GCP_v1.3.0'
              ? cis_logo
              : name === 'GCP-Well-Architected_v2020-07-02'
                ? cis_logo
                : name === 'Azure-Well-Architected_v2024-12' || name === 'Azure-Well-Architected_v2024-12-01'
                  ? azure_icon
                  : name === 'Google Cloud Architecture Framework'
                    ? gcp_well
                    : name === 'NIST-800-53_vRev4' || name === 'NIST_800_53'
                      ? nist_logo
                      : name === 'CIS-AWS_v1.3.0'
                        ? cis_logo
                        : name === 'CSA-CCM_v3.0.1' || name === 'ccmv3' || name === 'ccm_v4.0.5'
                          ? ccmd_logo
                          : name === 'AWS-Well-Architected_v2020-07-02'
                            ? aws_light
                            : name === 'POPI_Act_v2000' || name === 'popi_act'
                              ? popi_logo
                              : name === 'HIPAA_v2013' || name === 'hipaa' || name === 'HIPAA'
                                ? hipaa_logo
                                : name === 'SOC-2_v2017' || name === 'soc2' || name === 'SOC2'
                                  ? soc_logo
                                  : name === 'ISO-27001_v2013'
                                    ? iso_new
                                    : name === 'GDPR_v2016' || name === 'gdpr' || name === 'GDPR'
                                      ? gdpr_logo
                                      : name === 'PCI-DSS_v3.2.1' ||
                                          name === 'PCI-DSS_v4.0' ||
                                          name === 'pci_dss_v4.0' ||
                                          name === 'pci_dss_v3.2.1' ||
                                          name === 'PCI-DSS' ||
                                          name === 'PCI_DSS_v4'
                                        ? pci_logo
                                        : name === 'CSA-CCM_v4.0.5'
                                          ? ccmd_logo
                                          : name === 'NIST-800-53_vRev5'
                                            ? nist_logo
                                            : name === 'NYDFS' || name === 'nydfs'
                                              ? nydfs_logo // /--------------- New complaince family ------/
                                              : name === 'NIST_CSF' || name === 'nist_csf'
                                                ? nist_csf_logo
                                                : name === 'RBI_CSF' || name === 'rbi_csf'
                                                  ? rbi_logo // -------------------
                                                  : name === 'FISMA' || name === 'fisma'
                                                    ? fisma_logo
                                                    : name === 'FedRAMP' || name === 'fedramp'
                                                      ? fedramp_logo
                                                      : name === 'CMMC' || name === 'cmmc'
                                                        ? cmmc_logo
                                                        : name === 'AWS_FSBP'
                                                          ? aws_light
                                                          : name === 'AWS-CIS-EKS-1.4.0'
                                                            ? cis_logo
                                                            : name === 'AWS-CIS-EKS-1.1.0'
                                                              ? cis_logo
                                                              : name === 'GCP-CIS-GKE-1.5.0'
                                                                ? cis_logo
                                                                : name === 'SAMA_CSF' || name === 'sama_csf'
                                                                  ? sama
                                                                  : name === 'CBB' || name === 'cbb'
                                                                    ? cbb
                                                                    : name === 'Google Cloud Architecture Framework'
                                                                      ? gcp_well
                                                                      : name === 'cis' ||
                                                                          name === 'cis_database' ||
                                                                          name === 'cis_storage' ||
                                                                          name === 'cis_compute'
                                                                        ? cis_logo
                                                                        : name === 'nist_rev4' || name === 'nist_rev5'
                                                                          ? nist_logo
                                                                          : name === 'iso' ||
                                                                              name === 'iso_2022' ||
                                                                              name === 'ISO-27001_v2022'
                                                                            ? iso_new
                                                                            : name === 'azwaf'
                                                                              ? azwaf
                                                                              : name === 'mass_crm_17_control'
                                                                                ? mas_logo
                                                                                : name === 'hitrust_csf_control' ||
                                                                                    name === 'HITRUST_CSF_v11.5.0'
                                                                                  ? hitrust_logo
                                                                                  : name === 'SEBI_CSCRF_v1.0'
                                                                                    ? sebi_cscrf
                                                                                    : name === 'OWASP TOP 10'
                                                                                      ? owasp_top_10
                                                                                      : iso_logo
      }
      alt={name}
    />
  );
};

export default ComplianceIconMapping;
